import React, { useState } from "react";
import { TextInput } from "@sprout/text_input";
import useTranslation from "@hooks/use_translation";
import { PrimaryButton } from "@sprout/buttons";
import { router } from "@inertiajs/react";
import SocialLoginButtons, { type SocialLogin } from "@components/social_login_buttons";

const EMAIL_FORM_ID = "login-email-form";

type EmailFormProps = {
  jobBoardToken: string;
  createPath: string;
  email: string;
  socialLogin?: SocialLogin | null;
  setShowCode: (showCode: boolean) => void;
  setEmail: (email: string) => void;
};

const LoginEmail = (props: EmailFormProps) => {
  const { jobBoardToken, createPath, email, socialLogin, setShowCode, setEmail } = props;
  const { t } = useTranslation("misc");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const defaultErrorMessage = t("defaultError");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);

    if (!emailRegex.test(email)) {
      setError(t("login.invalidEmail"));
      return;
    }

    setIsSubmitting(true);

    router.post(
      createPath,
      {
        email: email,
        job_board: jobBoardToken,
      },
      {
        onError: (errors) => {
          setError(errors["email"] || errors["_server"] || defaultErrorMessage);
        },
        onFinish: () => setIsSubmitting(false),
        onSuccess: () => setShowCode(true),
      },
    );
  };

  return (
    <div className="login__auth">
      <form id={EMAIL_FORM_ID} className="login__form" onSubmit={submit}>
        <TextInput
          id="email-address"
          placeholder={t("login.email")}
          type="email"
          required
          onChange={(event) => setEmail(event.currentTarget.value || "")}
          maxLength={255}
          value={email}
          error={error}
          autoFocus
        />
      </form>

      <div className="login__actions">
        <PrimaryButton form={EMAIL_FORM_ID} loading={isSubmitting} type="submit">
          {t("login.sendCode")}
        </PrimaryButton>

        {socialLogin && (
          <SocialLoginButtons socialLogin={socialLogin} jobBoardToken={jobBoardToken} />
        )}
      </div>
    </div>
  );
};

export default LoginEmail;
